<template>
  <v-app class="grey-lighten">
    <v-content class="main">
      <v-container fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <!-- <center> <img :src="images.logo" width="250px" ></center> -->
            <!-- <v-flex lg4 md5 sm6> -->
            <center>
              <v-card class="rounded-card test" height="580px" max-height="600px" max-width="600px" id="loginBox">
                <v-toolbar flat dark color="#00166A" class="test" style="margin-bottom: 15px; height: 150px;">
                  <v-flex xs12 py-2><br /><br />
                    <v-icon
                      style="font-size: 60px; color: #54a3bc; margin-top: 40px; margin-bottom: -15px;">mdi-account-circle</v-icon>
                    </v-col><br /><br />
                    <strong style="font-weight: bold; font-size: 20px; color: #fff !important; height: 40px;">
                      Login </strong>
                  </v-flex>
                </v-toolbar>
                <v-card-text class="login2">
                  <v-form>
                    <v-text-field style="margin-bottom: 10px" prepend-icon="mdi-account" color="#54a3bc "
                      name="username" v-model="username" label="บัญชีผู้ใช้" ref="username"
                      :rules="[() => !!username || 'fill in username']">
                    </v-text-field>
                    <v-text-field prepend-icon="mdi-lock" v-model="password" ref="password" color="#54a3bc "
                      :append-icon="showUsername ? 'mdi-eye' : 'mdi-eye-off'" :type="showUsername ? 'text' : 'password'"
                      label="รหัสผ่าน" :rules="[() => !!password || 'fill in password']"
                      @click:append="showUsername = !showUsername" @keydown.enter="login"></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions style="margin-bottom: 20px">
                  <v-btn class="loginbtn" style="
                      margin: 0px 10px;
                      background-color: #013d92;
                      font-weight: bold;
                      font-size: 16px;
                      color: #fff !important;
                    " @click="login" round block>เข้าสู่ระบบ</v-btn>
                  <!-- <v-spacer></v-spacer> -->
                </v-card-actions>
                <a href="https://one.th/type_forgot_password" target="_blank" class="forgotpassword">ลืมรหัสผ่าน ?</a>
                <v-flex xs12 py-2><br /><br />
                  <strong style="color: rgb(116, 116, 116)" class="text-xs-right">คุณยังไม่มีบัญชี One Platform
                    ใช่หรือไม่ ?
                  </strong>
                  <br />
                  <a href="https://one.th/register" target="_blank" class="text-xs-right"
                    style="color: #000; font-weight: bold">ลงทะเบียน</a>
                </v-flex>
              </v-card>
              <br />
              <!-- <div style="color:#ff0000;">Our website is currently under construction</div> -->
            </center>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { TextEncoder } from "text-encoding";
import { sha256, sha224 } from "js-sha256";
if (!window["TextEncoder"]) {
  window["TextEncoder"] = TextEncoder;
}
export default {
  data() {
    return {
      showUsername: false,
      username: "",
      password: "",

      // getname: '',
      // firstname: '',
      // images: {
      //   logo: require('../assets/inetlogo.png')
      // }
    };
  },
  methods: {
    checkField() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) this.formHasErrors = true;
        this.$refs[f].validate(true);
      });
    },
    async login() {
      this.checkField();
      if (this.formHasErrors === false) {
        try {
          // if (this.typeTaxid === 'citizen') {
          let user_pass = this.username + " " + this.password;
          let buff = new Buffer(user_pass);
          let base64data = buff.toString("base64");
          var { data } = await this.axios.post(
            process.env.VUE_APP_APIHOST + "/login",
            {
              source: base64data,
            }
          );
          // console.log('/login admin: ', data)
          if (data.status === "invalid user or pass") {
            alert("Invalid username or password");
          } else if (data.status === "do not permission") {
            alert("Do not have permission to access");
          } else {
            this.firstname = data.first_name_eng;
            this.getname = data.first_name_eng + " " + data.last_name_eng;
            this.firstTHname = data.first_name_th;
            this.getTHname = data.first_name_th + " " + data.last_name_th;

            this.$cookies.set("firstname", this.firstname);
            this.$cookies.set("getname", this.getname);
            this.$cookies.set("firstTHname", this.firstTHname);
            this.$cookies.set("getTHname", this.getTHname);
            this.$cookies.set("role", data.role);
            this.$session.start();
            this.$cookies.set("token", data.token);
            // this.$cookies.set("account_id", data.id);
            // this.$cookies.set('taxid', this.taxid)
            // this.$cookies.set("ogtoken", data.token);
            // console.log('/login admin token: ', this.$cookies.get('token'));
            // this.$cookies.set("username", this.username);
            this.$router.push("/createPayment");
          }
        } catch (error) {
          console.log(error.message);
        }
      } else {
        this.checkField();
      }
    },
    handleView() {
      this.mobileView = window.innerWidth <= 990;
    },
  },
  computed: {
    form() {
      return {
        username: this.username,
        password: this.password,
      };
    },
  },
  created() {
    this.handleView();
    window.addEventListener("resize", this.handleView);
  },
};
</script>

<style>
.v-card__text.login2 {
  padding: 16px 16px 16px 16px !important;
}

.rounded-card {
  border-radius: 7px;
}

.loginbtn {
  font-family: "Sarabun", sans-serif;
  text-align: center;
  border-radius: 4px;
}

.forgotpassword {
  text-decoration: none;
  color: #000 !important;
  text-decoration: underline;
}

.forgotpassword:hover {
  color: #54a3bc;
}

.title {
  font-family: "Sarabun", sans-serif;
  color: #000;
}

@media (max-width: 500px) {
  .v-card#loginBox {
    width: 80%;
  }

  .btn.loginbtn {
    width: 20%;
  }
}

.main {
  background-image: url(../assets/Login.jpeg);
  /* background-image: url(../assets/Login.jpg); */
  background-size: cover;
}

.test {
  background-color: rgba(239, 245, 245, 0.274);
}

.container {
  padding: 16px;
}
</style>
